import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-container custom-cursor" }
const _hoisted_2 = {
  class: "cursor",
  ref: "cursor"
}
const _hoisted_3 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, null, 512),
    _createVNode(_component_Navbar),
    _createElementVNode("main", _hoisted_3, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, {
            name: "page",
            mode: "out-in",
            onBeforeEnter: _ctx.beforeEnter,
            onAfterEnter: _ctx.afterEnter
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { class: "page-content" }))
            ]),
            _: 2
          }, 1032, ["onBeforeEnter", "onAfterEnter"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Footer),
    _createElementVNode("button", {
      class: _normalizeClass(["scroll-to-top", { 'visible': _ctx.showScrollButton }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollToTop && _ctx.scrollToTop(...args)))
    }, _cache[1] || (_cache[1] = [
      _createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: "24",
        height: "24"
      }, [
        _createElementVNode("path", {
          fill: "white",
          d: "M12 4l-8 8h5v8h6v-8h5z"
        })
      ], -1)
    ]), 2)
  ]))
}